import SweetScroll from 'sweet-scroll'

function OnePageScroll (options) {
  const self = this
  self.currentIndex = 0
  self._initialized = false
  self.options = options

  let $sections = []
  let _sectionsIds = []
  let $container = false
  let _countSection = 0
  let _lockedInteractions = false
  let _lastY = false

  self.update = function () {
    _updateSections()
    _applyEvents()
  }
  self.moveTo = function (page) {
    if (self._initialized && !_lockedInteractions && page < _sectionsIds.length) {
      _lockedInteractions = true
      self._scroller.to('#' + _sectionsIds[page])
      self.currentIndex = page
    }
  }
  self.movePrev = function () {
    if (self.currentIndex > 0) { self.moveTo(self.currentIndex - 1) }
  }
  self.moveNext = function () {
    if (self.currentIndex < _countSection - 1) { self.moveTo(self.currentIndex + 1) }
  }

  const _touchHandler = (ev) => {
    if (self._initialized) {
      if (_lockedInteractions) {
        return true
      } else if (!_lastY) {
        _lastY = ev.touches[0].clientY
        return true
      }

      const $el = window.$(ev.srcElement)
      let $section
      let _direction
      if ($el.hasClass(self.options.sectionClass)) {
        $section = $el
      } else {
        $section = $el.parents('.' + self.options.sectionClass).first()
      }

      if ($section.length || $section[0]) {
        const touch = ev.touches[0]
        if (Math.abs(touch.clientY - _lastY) < self.options.threshold) {
          if (touch.clientY > _lastY) {
            _direction = 'up'
          } else if (touch.clientY < _lastY) {
            _direction = 'down'
          }
        }
        _lastY = touch.clientY
        const scrollTop = $section[0].pageYOffset || $section[0].scrollTop
        const isEnd = (scrollTop + $section[0].clientHeight) >= $section[0].scrollHeight

        if (isEnd && _direction === 'down') {
          self.moveNext()
        } else if (scrollTop <= 0 && _direction === 'up') {
          self.movePrev()
        } else {
          ev.stopImmediatePropagation()
          ev.stopPropagation()
        }
      }
    }
  }

  const _mouseHandler = (ev) => {
    if (self._initialized) {
      let _direction
      if (ev.wheelDelta >= 0) {
        _direction = 'up'
      } else {
        _direction = 'down'
      }

      let $section
      const $el = window.$(ev.srcElement)
      if ($el.hasClass(self.options.sectionClass)) {
        $section = $el
      } else {
        $section = $el.parents('.' + self.options.sectionClass).first()
      }

      if ($section.length || $section[0]) {
        const scrollTop = $section[0].pageYOffset || $section[0].scrollTop
        const isEnd = (scrollTop + $section[0].clientHeight === $section[0].scrollHeight)
        if (isEnd && _direction === 'down') {
        } else if (scrollTop <= 0 && _direction === 'up') {
        } else {
          ev.stopImmediatePropagation()
          ev.stopPropagation()
        }
      }
    }
  }

  const _windowMouseHandler = (ev) => {
    if (self._initialized) {
      const $el = window.$(ev.srcElement)
      if ($el.hasClass(self.options.sectionClass) || $el.parents('.' + self.options.sectionClass)) {
        if (ev.wheelDelta >= 0) {
          self.movePrev()
        } else {
          self.moveNext()
        }
      }
    }
  }

  const _updateSections = () => {
    $sections = document.getElementsByClassName(self.options.sectionClass)
    _countSection = $sections.length
    for (let i = 0; i < _countSection; i++) {
      _sectionsIds[i] = window.$($sections[i]).attr('id')
    }
  }

  const _completeSmoothScrollHandler = () => {
    _lastY = false
    _lockedInteractions = false
  }

  const _applyEvents = () => {
    for (let i = 0; i < _countSection; i++) {
      if (!window.$($sections[i]).data('onePageInit')) {
        window.$($sections[i]).data('onePageInit', true)
        $sections[i].addEventListener('mousewheel', _mouseHandler)
      }
    }
    $container = document.getElementById(self.options.containerId.replace('#', ''))
    if (!window.$($container).data('hasListener')) {
      window.$($container).data('hasListener', true)
      $container.addEventListener('touchmove', _touchHandler)
    }
    if (!window.__hasListener) {
      window.addEventListener('mousewheel', _windowMouseHandler)
      window.__hasListener = true
    }
  }

  self.destroy = () => {
    self._scroller.destroy()
    self._initialized = false
  }

  self.init = () => {
    if (!self._initialized) {
      self._initialized = true
      self.currentIndex = 0
      _lockedInteractions = false
      _updateSections()
      _applyEvents()
      self._scroller = new SweetScroll({
        duration: self.options.duration || 800,
        easing: 'easeInOutCubic',
        cancellable: false,
        complete: _completeSmoothScrollHandler
      }, self.options.containerId)
    } else {
      self.currentIndex = 0
      _lockedInteractions = false
    }
  }
  return self
}

export default {
  install: function (Vue, options) {
    const opts = Object.assign(options || {}, {name: '$onePage', threshold: 50})
    Vue.prototype[opts.name] = new OnePageScroll(opts)
  }
}
